// 用户仪表板布局组件
// 包含左侧固定导航栏 + 右侧内容区域

import { ResponsiveSidebarLayout } from '@/components/ui/responsive-shell'
import { UserMobileNav, UserSidebar } from '@/components/user-sidebar/UserSidebar'
import { Outlet } from 'react-router-dom'

export function UserLayout() {
  return (
    <ResponsiveSidebarLayout
      sidebar={<UserSidebar />}
      compactNavigation={<UserMobileNav />}
      contentInnerClassName="2xl:pt-6"
      sidebarBreakpoint="2xl"
    >
      <Outlet />
    </ResponsiveSidebarLayout>
  )
}
